import { render, staticRenderFns } from "./labelenPrint.vue?vue&type=template&id=3f745128&"
import script from "./labelenPrint.vue?vue&type=script&lang=js&"
export * from "./labelenPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports